var React = require('react');

function Linkedin (props) {
    return React.createElement("svg",props,[React.createElement("path",{"fill":"currentColor","stroke":"none","data-name":"Tracé 41","d":"M16,8a6,6,0,0,1,6,6v7H18V14a2,2,0,0,0-4,0v7H10V14a6,6,0,0,1,6-6Z","transform":"translate(-2 -2)","key":0}),React.createElement("rect",{"fill":"currentColor","stroke":"none","data-name":"Rectangle 76","width":"4","height":"12","transform":"translate(0 7)","key":1}),React.createElement("circle",{"fill":"currentColor","stroke":"none","data-name":"Ellipse 24","cx":"2","cy":"2","r":"2","key":2})]);
}

Linkedin.defaultProps = {"width":"20","height":"19","viewBox":"0 0 20 19"};

module.exports = Linkedin;

Linkedin.default = Linkedin;
